export const taxTypes = {
    SSN: "SSN",
    EIN: "EIN",
};
